export const rmaLookupFieldDropdown =  [
	{
	  title: "By RMA Number",
	  value: "rmaNumber"
	},
	{
	  title: "By Customer Name",
	  value: "customerName"
	},
	{
	  title: "By Customer Email",
	  value: "customerEmail"
	}
];

export const rmaLookupFXOFieldDropdown =  [
	{
	  title: "By Customer Email",
	  value: "customerEmail"
	},
	{
	  title: "By Phone Number",
	  value: "fxoPhoneNumber"
	}
]


// WEBPACK FOOTER //
// ./src/pages/rma/filter/rmaLookupFieldDropdown.js